/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@telus/koodo-ui-kit'

// Use kit Typography only for token-driven cases; plain spans preserve
// legacy inline-className behavior across existing screens.
const BodySmallBold = ({
  id, children, className = '', testId, textColor, tokens, variant, block, align
}) => {
  if (!tokens) {
    return (
      <span
        className={`text-xs font-h1 tracking-wider ${textColor || 'text-copy'} ${className}`}
        id={id}
        data-testid={testId}
      >
        {children}
      </span>
    )
  }

  const Wrapper = block ? 'div' : 'span'
  return (
    <Wrapper className={className} id={id} data-testid={testId}>
      <Typography block={block} align={align} variant={variant} tokens={tokens}>
        {children}
      </Typography>
    </Wrapper>
  )
}

BodySmallBold.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  textColor: PropTypes.string,
  testId: PropTypes.string,
  tokens: PropTypes.shape({}),
  variant: PropTypes.shape({}),
  block: PropTypes.bool,
  align: PropTypes.string
}

BodySmallBold.defaultProps = {
  variant: { size: 'small' },
  block: false,
  align: undefined
}

export default BodySmallBold
